import { useMutation } from "@apollo/client";
import Image from "components/base/Image";
import { useContext, useState } from "react";
import { formatDate } from "react-day-picker/moment";
import { Tag } from "../../../../components/base/base.js";
import ShipmentDelay from "./ShipmentDelay";
import ShipmentErrorComponent from "../../components/ShipmentError.js";
import ShipmentContext from "../ShipmentContext";
import ShipmentErrorForm from "./ShipmentErrorForm";

import Button from "components/base/Button.jsx";
import { DELETE_SHIPMENT_ERROR } from "./graphql";

function ShipmentError({ shipmentStatusId, shipmentStatusError }) {
  const { state, dispatch } = useContext(ShipmentContext);
  const [showErrorProducts, setShowErrorProducts] = useState(
    shipmentStatusError.shipmentStatusErrorProductRows.length < 3,
  );
  const [editingShipmentError, setEditingShipmentError] = useState(null);

  const [deleteShipmentError, { loading }] = useMutation(
    DELETE_SHIPMENT_ERROR,
    {
      onCompleted: ({ deleteShipmentError }) => {
        dispatch({
          type: "deleteShipmentStatusError",
          payload: {
            shipmentStatusId,
            shipmentStatusErrorId: deleteShipmentError.id,
            shipment: deleteShipmentError.shipment,
          },
        });
      },
    },
  );

  if (editingShipmentError)
    return (
      <div className="mt-4 lg:mt-6">
        <ShipmentErrorForm
          editingShipmentStatusError={shipmentStatusError}
          shipmentStatusId={shipmentStatusId}
          hideForm={(_) => setEditingShipmentError(null)}
        />
      </div>
    );

  return (
    <div className="box">
      <div>
        <div className="lg:flex justify-between items-start">
          <div>
            <div className="text-gray-600 dark:text-gray-300">
              {formatDate(shipmentStatusError.created * 1000, "YYYY-MM-DD")}
            </div>
            <ShipmentErrorComponent
              prefix="Error "
              className="mt-2"
              code={shipmentStatusError.error.code}
              description={shipmentStatusError.error.description}
            />
          </div>
          <div className="mt-2 lg:mt-0 text-right flex space-x-4">
            <Button
              onClick={() => setEditingShipmentError(shipmentStatusError)}
            >
              Edit Error
            </Button>
            <Button
              danger
              loading={loading}
              onClick={() => {
                if (
                  window.confirm(
                    `Are you sure you want to delete this shipment error?`,
                  )
                ) {
                  deleteShipmentError({
                    variables: { id: shipmentStatusError.id },
                  });
                }
              }}
            >
              Delete Error
            </Button>
          </div>
        </div>

        {shipmentStatusError.notes ? (
          <div className="whitespace-pre-wrap mt-2">
            <label htmlFor="">Notes: </label>
            {shipmentStatusError.notes}
          </div>
        ) : null}
      </div>

      {shipmentStatusError.hasDelay ? (
        <div className="mt-6 rounded-lg p-4 bg-gray-100 dark:bg-gray-800">
          <ShipmentDelay days={shipmentStatusError.delayDays} />
        </div>
      ) : null}

      {shipmentStatusError.shipmentStatusErrorFactories.length > 0 && (
        <div className="mt-1 lg:mt-4 flex flex-wrap">
          {shipmentStatusError.shipmentStatusErrorFactories.map((i) => (
            <Tag
              className="text-xs mr-2 mb-2"
              title={i.factory.nickName}
              key={i.id}
            />
          ))}
        </div>
      )}

      {shipmentStatusError.shipmentStatusErrorProductRows.length > 0 ? (
        <div className="mt-2 lg:mt-4">
          <Button onClick={() => setShowErrorProducts((prev) => !prev)}>
            {showErrorProducts ? "Hide error products" : "Show error products"}
          </Button>
          {showErrorProducts ? (
            <div className="pt-2 lg:p-4 mt-2 lg:mt-4 bg-gray-100 dark:bg-gray-800 rounded-lg">
              <div className="text-base font-bold">Products</div>
              <div className="mt-1 lg:mt-4">
                {shipmentStatusError.shipmentStatusErrorProductRows.map(
                  (row) => (
                    <div
                      className="border-t border-gray-200 dark:border-gray-700 py-2"
                      key={row.id}
                    >
                      <div className="lg:flex justify-between text-xs">
                        <div className="flex items-center">
                          <div className="flex items-center">
                            {row.shipmentInvoiceRow.product?.images.map(
                              (i, index) => (
                                <Image
                                  size="h-12"
                                  className="mr-2"
                                  src={i.thumb}
                                  key={index}
                                />
                              ),
                            )}
                          </div>
                          <div>{row.shipmentInvoiceRow.productName}</div>
                        </div>
                        <div>&times; {row.shipmentInvoiceRow.qty}</div>
                      </div>
                    </div>
                  ),
                )}
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

export default ShipmentError;
